/**
 * Copyright (c) 2018
 * @summary Application Domain Element Table Structure
 * @author Mangesh Pimprikar,Ankur Vishwakarma,Poonam Banode,Irfan Bagwan
 *
 */
import React, { Component } from 'react';

import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import LogsTable from '../../../patient-source/Patients/Logs/LogsTable';
import { defaultCellWidth, getColumns } from '../../../patient-source/Patients/Logs/LogsTableService';
import { showEncounterColumn } from '../ElementSetupNew/defaultLogCheckOptions';
import ItemGroupFormPreview from '../ItemGroupFormPreview/ItemGroupFormPreview';
import ElementPreviewModal from '../ItemGroupTemplatePreviewModal/ItemGroupTemplatePreviewModal';

import './DomainTable.scss';

const customClassObject = {
  textbox: {
    containerClass: 'p-0',
    elementClass: 'form-control select-width'
  },
  dropdown: {
    containerClass: 'p-0',
    elementClass: 'form-control select-width'
  },
  date: {
    containerClass: 'custonDate',
    elementClass: 'p-0'
  },
  textarea: {
    containerClass: 'display-inline',
    elementClass: 'form-control'
  },
  Time: {
    containerClass: '',
    elementClass: 'select-width p-0'
  },
  checkbox: {
    containerClass: 'p-0',
    elementClass: ''
  },
  label: {
    containerClass: 'p-0',
    elementClass: ''
  },
  file: {
    containerClass: 'input-group ml-0 position-relative',
    elementClass: 'select-width custom-file-input'
  },
  reminder: {
    containerClass: 'col-md-12 ml-0 position-relative pl-0',
    elementClass: ''
  }
};

class DomainTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPreviewFormPopUpData: false,
      inputValuesMap: {}
    };
    this.predefinedRows = [];
  }

  renderThead() {
    return (
      this.props.tableData &&
      this.props.tableData[0].columnList.map((vs, ix) => {
        return <th key={ix}>{vs}</th>;
      })
    );
  }

  openFormPopup = () => {
    ModalBoxes.open({
      component: <ElementPreviewModal renderFormData={this.renderForm(this.props)} header={this.state.domainElement} />,
      title: `Item Group Preview ${this.state.domainElement}`
    });
  };

  renderForm = props => {
    return (
      <div className="row col-xs-12 col-md-12 element-scroll">
        <div className="form-group pt-2 row col-xs-12 col-md-12 position-relative ml-0 mr-0">
          <ItemGroupFormPreview formData={props.tableData[0]} customClassObject={customClassObject} />
        </div>
      </div>
    );
  };

  // get column value
  getColValues = () => {
    if (typeof this.props.predefinedTableData.predefinedColumnValues === 'string') {
      return this.props.predefinedTableData.predefinedColumnValues.split(',');
    }
    if (typeof this.props.predefinedTableData.predefinedColumnValues === 'object') {
      return this.props.predefinedTableData.predefinedColumnValues;
    }
    return [];
  };

  componentDidMount() {
    if (!this.props.userEnd) {
      this.setState({ showPreviewFormPopUpData: true });
    }
    if (
      this.props.displayElementIconTableType &&
      this.props.predefinedTableData &&
      this.props.predefinedTableData.predefinedColumnName
    ) {
      this.props.tableData &&
        this.props.tableData[0].columnList.unshift(this.props.predefinedTableData.predefinedColumnName);
      this.predefinedRows = this.getColValues(); // this.props.predefinedTableData.predefinedColumnValues
    }
    this.props.tableData &&
      this.props.tableData[0].labelList.forEach(item => {
        if (item.inputType === 'radio') {
          item.inputValue = 0;
        }
      });
  }

  componentWillUnmount() {
    if (
      this.props.displayElementIconTableType &&
      this.props.predefinedTableData &&
      this.props.predefinedTableData.predefinedColumnName
    ) {
      this.props.tableData && this.props.tableData[0].columnList.shift();
    }
  }

  render({ state, props } = this) {
    return (
      <div>
        {this.props.userEnd && (
          <div className="col float-right my-1 add-btn-bg">
            <span className="cursor-pointer" onClick={() => this.openFormPopup()}>
              <span className="float-right c-w cursor-pointer">Add</span>
              <span className="add-btn">
                <i className="material-icons">add</i>
              </span>
            </span>
          </div>
        )}
        {this.state.showPreviewFormPopUpData && <h5 className="subtitle mt-2 col-md-12">Table View </h5>}
        <div className="row col-12 p-0 m-0 previewTable-scroll">
          {this.props.elementIcon === 'Logs' ? (
            <LogsTable
              columns={getColumns(
                this.props.tableData[0].labelList.filter(column => column.isChecked),
                showEncounterColumn(this.props.tableData[0].domainCode),
                this.props.tableData[0].domainCode
              )}
              showPagination={false}
              defaultCellWidth={defaultCellWidth}
            />
          ) : (
            <table className="table table-responsive-lg border activity-table predefined-table mb-2">
              <thead>
                <tr valign="middle">{this.renderThead()}</tr>
              </thead>
              {props.displayElementIconTableType ? (
                <tbody className="text-center">
                  {this.predefinedRows &&
                    this.predefinedRows.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item}</td>
                          <td
                            colSpan={this.props.tableData[0].columnList.reduce((ac, currentV) => {
                              return ac + 1;
                            }, 0)}
                          />
                        </tr>
                      );
                    })}
                </tbody>
              ) : (
                <tbody className="text-center">
                  <tr>
                    <td
                      colSpan={this.props.tableData[0].columnList.reduce((ac, currentV) => {
                        return ac + 1;
                      }, 0)}
                    >
                      No record found.
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          )}
        </div>
        {this.state.showPreviewFormPopUpData && <h5 className="subtitle mt-2 col-md-12">Form Popup View (+Add) : </h5>}
        {this.state.showPreviewFormPopUpData && this.renderForm(this.props)}
      </div>
    );
  }
}

export default DomainTable;
